import { render } from "./NokoriComparePage.vue?vue&type=template&id=4d6e1983&scoped=true"
import script from "./NokoriComparePage.vue?vue&type=script&lang=js"
export * from "./NokoriComparePage.vue?vue&type=script&lang=js"

import "./NokoriComparePage.vue?vue&type=style&index=0&id=4d6e1983&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6e1983"]])

export default __exports__